import { AssessmentTwoTone, Inventory, Settings, ShoppingBasket, Today } from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Box, Tab, Tabs } from '@mui/material';
import { FC, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useBreakpoint } from '../../../shared/hooks/breakpoint.hook';
import { Account } from '../account/account.component';

type navItem = {
    label: string;
    value: string;
    to: string;
    icon: ReactNode;
    hasPermission?: boolean;
};

export const Navigation: FC = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const selectedTab = useMemo(() => location.pathname.split('/')[1] || 'planning', [location]);
    const breakPoint = useBreakpoint('md');

    const navItems: navItem[] = [
        {
            label: t('planning'),
            value: 'planning',
            to: '/planning',
            icon: <Today />,
        },
        {
            label: t('stock'),
            value: 'stock',
            to: '/stock',
            icon: <Inventory />,
        },
        {
            label: t('fead'),
            value: 'fead',
            to: '/fead',
            icon: <ShoppingBasket />,
        },
        {
            label: t('reports'),
            value: 'reports',
            to: '/reports',
            icon: <AssessmentTwoTone />,
        },
        {
            label: t('admin'),
            value: 'admin',
            to: '/admin',
            icon: <Settings />,
        },
    ];

    return breakPoint ? (
        <>
            <Tabs indicatorColor="primary" textColor="primary" sx={{ flexGrow: 1 }} value={selectedTab}>
                {navItems.map(
                    ({ label, value, to, hasPermission = true }) =>
                        hasPermission && <Tab key={value} label={label} value={value} component={Link} to={to} />,
                )}
            </Tabs>
            <Account />
        </>
    ) : (
        <>
            <Box sx={{ flexGrow: 1 }} />
            <Account />
            <BottomNavigation showLabels value={selectedTab}>
                {navItems?.map(
                    ({ label, value, to, icon, hasPermission = true }) =>
                        hasPermission && (
                            <BottomNavigationAction
                                key={value}
                                label={label}
                                value={value}
                                component={Link}
                                to={to}
                                icon={icon}
                            />
                        ),
                )}
            </BottomNavigation>
        </>
    );
};
